export default {"src":"/_next/static/media/minus_filled.2ba184a6.svg","height":24,"width":24};